@if (shouldShowLink()) {
    <a [href]="whatsAppLink()"
       target="_blank"
       class="text-success text-decoration-none d-inline-flex align-items-center gap-1"
       title="Abrir no WhatsApp">
        @if (showIcon()) {
            <i class="ti ti-brand-whatsapp"></i>
        }
        {{ fullPhone() }}
    </a>
} @else {
    @if (showIcon()) {
        <i class="ti ti-{{isFax() ? 'printer' : 'phone'}}"></i>
    }
    {{ fullPhone() }}
}

